import { render, staticRenderFns } from "./SupportView.vue?vue&type=template&id=08ff20a8&scoped=true&"
import script from "./SupportView.vue?vue&type=script&lang=js&"
export * from "./SupportView.vue?vue&type=script&lang=js&"
import style0 from "./SupportView.vue?vue&type=style&index=0&id=08ff20a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ff20a8",
  null
  
)

export default component.exports